
// rounting
import TransactionFormulaList from './transaction-formula-list/transaction-formula-list.vue';
import TransactionFormulaDetail from './transaction-formula-detail/transaction-formula-detail.vue';
import BatchDetail from './batch-detail/transaction-formula-detail.vue';
import NoticeFormulaList from './notice-formula-list/notice-formula-list.vue';
import NoticeFormulaDetail from './notice-formula-detail/notice-formula-detail.vue';
import BatchFormulaDetail from './batch-formula-detail/notice-formula-detail.vue';
import TradingRulesList from './trading-rules-list/trading-rules-list.vue';
import TradingRulesDetail from './trading-rules-detail/trading-rules-detail.vue';
import SystemUpdateList from './system-update-list/system-update-list.vue';
import SystemUpdateDetail from './system-update-detail/system-update-detail.vue';
import MortgageList from './mortgage-list/index.vue';
import MortgageDetail from './mortgage-detail/index.vue';
export default [
  {
    path: 'list',
    name: 'TransactionFormulaList',
    component: TransactionFormulaList,
    meta: {
      title: '成交公示',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'detail',
    name: 'TransactionFormulaDetail',
    component: TransactionFormulaDetail,
    meta: {
      title: '公示详情',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'batchDetail',
    name: 'BatchDetail',
    component: BatchDetail,
    meta: {
      title: '公示详情',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'noticeList',
    name: 'NoticeFormulaList',
    component: NoticeFormulaList,
    meta: {
      title: '交易鉴证',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'noticeDeatil',
    name: 'NoticeFormulaDetail',
    component: NoticeFormulaDetail,
    meta: {
      title: '鉴证详情',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'witnessbatchDeatil',
    name: 'BatchFormulaDetail',
    component: BatchFormulaDetail,
    meta: {
      title: '鉴证详情',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'trading-rules-list/:type',
    name: 'TradingRulesList',
    component: TradingRulesList,
    meta: {
      title: '变更项目公示',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'trading-rules-detail',
    name: 'tradingRulesDetail',
    component: TradingRulesDetail,
    meta: {
      title: '变更项目公示详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  },
  {
    path: 'system-update-list/:type',
    name: 'SystemUpdateList',
    component: SystemUpdateList,
    meta: {
      title: '系统更新公示',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'system-update-detail',
    name: 'SystemUpdateDetail',
    component: SystemUpdateDetail,
    meta: {
      title: '系统更新公示详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  },
  {
    path: 'mortgage-list',
    name: 'MortgageList',
    component: MortgageList,
    meta: {
      title: '抵押公示',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: 'mortgage-detail',
    name: 'MortgageDetail',
    component: MortgageDetail,
    meta: {
      title: '抵押公示详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  }
];
